import { render } from "./BlogGridTwo.vue?vue&type=template&id=21de2d61"
import script from "./BlogGridTwo.vue?vue&type=script&lang=js"
export * from "./BlogGridTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__